import { useEffect, useState } from 'react';
import { CurrentUser } from 'types';
import api from 'utils/api-services';

const useCurrentUser = () => {
  const [currentUser, setCurrentUser] = useState<CurrentUser>({ userId: '0' });

  useEffect(() => {
    api.getCurrentUserId().then((res) => {
      setCurrentUser(res);
    });
  }, []);

  return currentUser;
};

export default useCurrentUser;
